import { TeachingBlockCardType } from './types';

/**
 * Durchsuchbarer Text einer Epochen-Karte (Fach, Label, Klassen, Lehrer) als
 * lowercase-String. Wird sowohl für den Stapelfilter (`CardPicker`) als auch für
 * das Dimming platzierter Karten im Grid (`data-search-text`) verwendet, damit die
 * Match-Logik an einer Stelle liegt.
 */
export function getCardSearchText(card: TeachingBlockCardType): string {
  return [
    card.subject?.name,
    card.subject?.shortName,
    card.label,
    card.labelShort,
    ...card.classes.flatMap((c) => [c.name, c.shortName]),
    ...card.teachers.flatMap((teacher) => [teacher.shortName, teacher.displayNameShort ?? undefined]),
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

/** `true`, wenn die Karte zum (bereits getrimmten) Suchstring passt; leere Suche = alle. */
export function cardMatchesSearch(card: TeachingBlockCardType, search: string): boolean {
  const needle = search.trim().toLowerCase();
  if (!needle) return true;
  return getCardSearchText(card).includes(needle);
}
